import { GET_BENCHMARKS } from "../actions";
import { IFilterRequest } from "../models";

export function benchmarksReducer(state: {}[] = [], action) {
	switch (action.type) {
		case GET_BENCHMARKS:
			return action["payload"] || [];
		default: return state;
	}
}


// WEBPACK FOOTER //
// ./src/client/reducers/benchmarks.ts